import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useMemo, useState } from 'react';
import cn from 'classnames';
import { Eye } from '../../icons';
import { getTestIds } from '../../utils/TestIds';
import { PasswordStrengthMeter } from '../PasswordStrengthMeter';
import { TextField } from '../TextField';
import styles from './PasswordField.module.scss';
export const GetPasswordFieldTID = (parentTestId)=>getTestIds(parentTestId);
// See note on BaseTextField — forwardRef + MUI types collapses BiProps' discriminated union.
const PasswordFieldImpl = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { showStrengthMeter, strengthScore, className, error, helperText } = _ref1, props = _object_without_properties(_ref1, [
        "showStrengthMeter",
        "strengthScore",
        "className",
        "error",
        "helperText"
    ]), [ref] = _rest;
    const [showPassword, setShowPassword] = useState(false);
    const testIds = useMemo(()=>GetPasswordFieldTID(props.testId), [
        props.testId
    ]);
    const meterScore = strengthScore !== null && strengthScore !== void 0 ? strengthScore : null;
    const meterActive = showStrengthMeter && meterScore !== null;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.root, className),
        "data-testid": testIds.PasswordFieldTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(TextField, _object_spread({
                collapseHelperText: true,
                ref: ref,
                type: showPassword ? 'text' : 'password',
                error: meterActive ? false : error,
                helperText: meterActive ? undefined : helperText,
                suffix: /*#__PURE__*/ _jsx("span", {
                    className: styles.eye,
                    onClick: ()=>setShowPassword(!showPassword),
                    children: /*#__PURE__*/ _jsx(Eye, {
                        size: 18
                    })
                }),
                label: "Password"
            }, props)),
            showStrengthMeter && /*#__PURE__*/ _jsx(PasswordStrengthMeter, {
                score: meterScore,
                testId: testIds.PasswordFieldTestIds.StrengthMeter()
            })
        ]
    });
});
export const PasswordField = PasswordFieldImpl;
